import { useEffect, useRef, useState } from 'react';
import sharedStyles from '../TextArea.module.scss';

interface ITextDisplay {
  value: string;
  label?: string;
  variant?: 'fullSize' | 'halfSize';
}

function TextAreaDisplay({ value, label, variant = 'fullSize' }: ITextDisplay) {
  const displayRef = useRef<HTMLDivElement>(null);
  const [showScrollbar, setShowScrollbar] = useState(false);

  useEffect(() => {
    const el = displayRef.current;
    if (el) {
      // Compare the actual scroll height with the visible height
      setShowScrollbar(el.scrollHeight > el.clientHeight);
    }
  }, [value]);

  return (
    <div className={`${sharedStyles.textAreaWrapper} ${sharedStyles[variant]}`}>
      {label && <span className={sharedStyles.displayLabel}>{label}</span>}
      <div
        ref={displayRef}
        className={`
          ${sharedStyles.display} 
          ${showScrollbar ? sharedStyles.scrollable : ''} 
        `}
      >
        {value}
      </div>
    </div>
  );
}

export default TextAreaDisplay;
